import React, { useState } from "react";
import { createConfirmBookingConfig, validateConfirmBookingConfig } from "../utils/confirmBookingValidation";

export default function ConfirmBookingEditor({ node, onClose, onSave }) {
  const [config, setConfig] = useState(() => ({ ...createConfirmBookingConfig(), ...(node?.data?.config || {}) }));
  const [error, setError] = useState("");
  const save = () => {
    const result = validateConfirmBookingConfig(config);
    if (!result.isValid) return setError(result.message);
    onSave?.({ ...node, data: { ...(node.data || {}), config } });
    onClose?.();
  };
  return <div className="fixed inset-0 z-[1001] flex items-center justify-center bg-black/10 p-6">
    <div className="w-full max-w-lg rounded-lg bg-white p-5 shadow-xl">
      <h2 className="text-lg font-bold">Confirm Booking</h2>
      <p className="mt-1 text-sm text-slate-500">Converts the current scheduling hold into a confirmed Booking.</p>
      <label className="mt-5 flex items-start gap-3 rounded-md border border-slate-200 p-3">
        <input type="checkbox" className="mt-1 h-4 w-4" checked={!!config.createPayableOrder}
          onChange={e => setConfig({ ...config, createPayableOrder: e.target.checked })} />
        <span><span className="block text-sm font-semibold text-slate-800">Create a Commerce Order for this booking</span>
          <span className="mt-1 block text-xs text-slate-500">Requires this path to prepare and submit the service through Commerce first. On confirmation, XploreByte creates the financial Order from that finalized Commerce evidence.</span></span>
      </label>
      {!config.createPayableOrder ? <>
        <label className="mt-5 block text-xs font-semibold">Optional Commerce transaction session key</label>
        <input className="mt-2 w-full rounded-md border px-3 py-2 text-sm" placeholder="commerce.transaction_id"
          value={config.commerceTransactionSessionKey || ""} onChange={e => setConfig({ ...config, commerceTransactionSessionKey: e.target.value })} />
      </> : <p className="mt-3 rounded-md bg-cyan-50 p-3 text-xs text-cyan-800">Payable mode uses the finalized Commerce transaction produced by Review &amp; Submit. The optional transaction key is not used.</p>}
      <p className="mt-3 text-xs text-slate-500">Inputs: scheduling.intent_id. Outputs: scheduling.booking_id, scheduling.booking_reference, scheduling.booking_status.</p>
      {error && <p role="alert" className="mt-3 text-sm text-red-600">{error}</p>}
      <div className="mt-5 flex justify-end gap-2"><button className="rounded border px-4 py-2" onClick={onClose}>Cancel</button><button className="rounded bg-emerald-600 px-4 py-2 font-semibold text-white" onClick={save}>Save node</button></div>
    </div>
  </div>;
}
